import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectConfig } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PataviumRole } from '../../../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { DataService } from '../../../../../services/data.service';
import { NotificationService } from '../../../../../services/notification.service';
import { AutocompleteService } from '../../../../../services/autocomplete.service';
import { ActionUser, UserlistComponent } from '../../../../common/userlist/userlist.component';
import { ActivatedRoute } from '@angular/router';
import { QueryParams } from '../../../../../helpers/queryParams.enum';
import { ModalMode } from '../../../../../helpers/modalMode.enum';
import { AuthService } from '../../../../../services/auth.service';
import { LocalStorageService } from '../../../../../services/local-storage.service';
import { SessionStorageService } from '../../../../../services/session-storage.service';

@Component({
    selector: 'app-agency-operators',
    templateUrl: '../../../../common/userlist/userlist.component.html',
    styleUrls: ['../../../../common/userlist/userlist.component.css']
})
export class AgencyOperatorsComponent extends UserlistComponent implements OnInit, AfterViewInit {
    @ViewChild('newUser') newUser: TemplateRef<any>; //TODO: rewrite openModal

    constructor(
        protected toastr: ToastrService,
        protected api: DataService,
        protected modalService: NgbModal,
        protected modalConfig: NgbModalConfig,
        protected config: NgSelectConfig,
        protected notification: NotificationService,
        protected ptautocomplete: AutocompleteService,
        protected ngxService: NgxUiLoaderService,
        private activatedRoute: ActivatedRoute,
        protected authService: AuthService,
        protected localStorage: LocalStorageService
    ) {
        super(
            toastr,
            api,
            modalService,
            modalConfig,
            config,
            notification,
            ptautocomplete,
            ngxService,
            authService,
            localStorage
        );
        this.usersRole = PataviumRole.AgencyOperator;
        this.preferredGroup = SessionStorageService.sessionInfo.userId;
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngAfterViewInit(): void {
        //setTimeout evita un bug
        setTimeout(() => {
            this.activatedRoute.queryParams.subscribe(response => {
                const modalMode = response[QueryParams.ModalMode];
                if (modalMode === ModalMode.Create) {
                    console.log('OPEN MODAL CREATE');
                    this.openModal(this.newUser, ActionUser.Create, null);
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/agency/users/agency-operators/agency-operators.component.ts